// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.promo-slider {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
  max-width: 1100px;
  margin: 0 auto 32px;
  padding-top: 8px;
}

.promo-slider__badge {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  padding: 12px 28px;
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 18px;
  letter-spacing: 0.05em;
  color: #fff;
  background: #d9151c;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
}

.promo-slider__slide {
  position: relative;
  width: 100%;
  max-width: 990px;
  aspect-ratio: 990 / 342;
  padding: 0;
  border: 2px solid #fff;
  border-radius: 26px;
  cursor: pointer;
  overflow: hidden;
  background: transparent;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
}

.promo-slider__slide-bg {
  display: block;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}

.promo-slider--empty {
  justify-content: center;
}

.promo-slider--empty .promo-slider__slide {
  max-width: 990px;
  cursor: default;
}

.promo-slider__slide--static {
  pointer-events: none;
}

.promo-slider__empty-hint {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 32px;
  text-align: center;
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.92);
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.45);
}

.promo-slider__slide-bg--placeholder {
  background: linear-gradient(135deg, #3d3530 0%, #5e4f4a 100%);
}

.promo-slider__arrow {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 72px;
  min-height: 56px;
  padding: 0 0 0 0;
  border: none;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  cursor: pointer;
}

.promo-slider__arrow-svg {
  display: block;
  width: 64px;
  height: auto;
  max-height: 42px;
}

.promo-slider__dots {
  position: absolute;
  bottom: -28px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 12px;
  align-items: center;
}

.promo-slider__dot {
  width: 19px;
  height: 19px;
  padding: 0;
  border: 2px solid #5e4f4a;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
}

.promo-slider__dot--active {
  border: none;
  background: #4e3f3a;
}

.promo-slider__backdrop {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.45);
}

.promo-slider__modal {
  max-width: 480px;
  width: 100%;
  padding: 24px 28px;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  font-family: 'Roboto', sans-serif;
  color: #4e3f3a;
}

.promo-slider__modal-title {
  margin: 0 0 12px;
  font-size: 22px;
  font-weight: 600;
}

.promo-slider__modal-text {
  margin: 0 0 20px;
  font-size: 16px;
  line-height: 1.45;
  white-space: pre-wrap;
}

.promo-slider__modal-code {
  margin: 0 0 16px;
  font-size: 16px;
  font-weight: 600;
}

.promo-slider__modal-close {
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  background: #4e3f3a;
  color: #fff;
  font-size: 15px;
  cursor: pointer;
}

@media (max-width: 1100px) {
  .promo-slider {
    gap: 10px;
  }

  .promo-slider__arrow {
    min-width: 56px;
  }
}

@media (max-width: 900px) {
  .promo-slider {
    flex-wrap: wrap;
    margin-bottom: 38px;
    gap: 8px;
  }

  .promo-slider__arrow {
    min-width: 42px;
    min-height: 38px;
  }

  .promo-slider__arrow-svg {
    width: 34px;
    max-height: 24px;
  }

  .promo-slider__arrow--prev {
    order: 2;
  }

  .promo-slider__slide {
    order: 1;
    flex: 1 1 100%;
    max-width: none;
  }

  .promo-slider__arrow--next {
    order: 3;
  }

  .promo-slider__badge {
    padding: 8px 14px;
    font-size: 14px;
    border-radius: 12px;
  }

  .promo-slider__dots {
    bottom: -22px;
    gap: 9px;
  }

  .promo-slider__dot {
    width: 14px;
    height: 14px;
  }
}

@media (max-width: 430px) {
  .promo-slider {
    margin-bottom: 30px;
  }

  .promo-slider__slide {
    border-radius: 14px;
  }

  .promo-slider__empty-hint {
    padding: 12px;
    font-size: 13px;
  }

  .promo-slider__backdrop {
    padding: 12px;
  }

  .promo-slider__modal {
    padding: 14px 14px;
    border-radius: 14px;
  }

  .promo-slider__modal-title {
    margin-bottom: 8px;
    font-size: 18px;
  }

  .promo-slider__modal-text,
  .promo-slider__modal-code {
    font-size: 14px;
    margin-bottom: 12px;
  }

  .promo-slider__modal-close {
    width: 100%;
    padding: 9px 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PromotionsSlider.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;EACV,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;AACF","sourcesContent":[".promo-slider {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  width: 100%;\n  max-width: 1100px;\n  margin: 0 auto 32px;\n  padding-top: 8px;\n}\n\n.promo-slider__badge {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  padding: 12px 28px;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n  letter-spacing: 0.05em;\n  color: #fff;\n  background: #d9151c;\n  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n  border-radius: 20px;\n}\n\n.promo-slider__slide {\n  position: relative;\n  width: 100%;\n  max-width: 990px;\n  aspect-ratio: 990 / 342;\n  padding: 0;\n  border: 2px solid #fff;\n  border-radius: 26px;\n  cursor: pointer;\n  overflow: hidden;\n  background: transparent;\n  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n}\n\n.promo-slider__slide-bg {\n  display: block;\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  background-position: center;\n}\n\n.promo-slider--empty {\n  justify-content: center;\n}\n\n.promo-slider--empty .promo-slider__slide {\n  max-width: 990px;\n  cursor: default;\n}\n\n.promo-slider__slide--static {\n  pointer-events: none;\n}\n\n.promo-slider__empty-hint {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px 32px;\n  text-align: center;\n  font-family: 'Roboto', sans-serif;\n  font-size: 16px;\n  line-height: 1.45;\n  color: rgba(255, 255, 255, 0.92);\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.45);\n}\n\n.promo-slider__slide-bg--placeholder {\n  background: linear-gradient(135deg, #3d3530 0%, #5e4f4a 100%);\n}\n\n.promo-slider__arrow {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 72px;\n  min-height: 56px;\n  padding: 0 0 0 0;\n  border: none;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n  cursor: pointer;\n}\n\n.promo-slider__arrow-svg {\n  display: block;\n  width: 64px;\n  height: auto;\n  max-height: 42px;\n}\n\n.promo-slider__dots {\n  position: absolute;\n  bottom: -28px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.promo-slider__dot {\n  width: 19px;\n  height: 19px;\n  padding: 0;\n  border: 2px solid #5e4f4a;\n  border-radius: 50%;\n  background: #fff;\n  cursor: pointer;\n}\n\n.promo-slider__dot--active {\n  border: none;\n  background: #4e3f3a;\n}\n\n.promo-slider__backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(0, 0, 0, 0.45);\n}\n\n.promo-slider__modal {\n  max-width: 480px;\n  width: 100%;\n  padding: 24px 28px;\n  border-radius: 20px;\n  background: #fff;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n  font-family: 'Roboto', sans-serif;\n  color: #4e3f3a;\n}\n\n.promo-slider__modal-title {\n  margin: 0 0 12px;\n  font-size: 22px;\n  font-weight: 600;\n}\n\n.promo-slider__modal-text {\n  margin: 0 0 20px;\n  font-size: 16px;\n  line-height: 1.45;\n  white-space: pre-wrap;\n}\n\n.promo-slider__modal-code {\n  margin: 0 0 16px;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.promo-slider__modal-close {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 12px;\n  background: #4e3f3a;\n  color: #fff;\n  font-size: 15px;\n  cursor: pointer;\n}\n\n@media (max-width: 1100px) {\n  .promo-slider {\n    gap: 10px;\n  }\n\n  .promo-slider__arrow {\n    min-width: 56px;\n  }\n}\n\n@media (max-width: 900px) {\n  .promo-slider {\n    flex-wrap: wrap;\n    margin-bottom: 38px;\n    gap: 8px;\n  }\n\n  .promo-slider__arrow {\n    min-width: 42px;\n    min-height: 38px;\n  }\n\n  .promo-slider__arrow-svg {\n    width: 34px;\n    max-height: 24px;\n  }\n\n  .promo-slider__arrow--prev {\n    order: 2;\n  }\n\n  .promo-slider__slide {\n    order: 1;\n    flex: 1 1 100%;\n    max-width: none;\n  }\n\n  .promo-slider__arrow--next {\n    order: 3;\n  }\n\n  .promo-slider__badge {\n    padding: 8px 14px;\n    font-size: 14px;\n    border-radius: 12px;\n  }\n\n  .promo-slider__dots {\n    bottom: -22px;\n    gap: 9px;\n  }\n\n  .promo-slider__dot {\n    width: 14px;\n    height: 14px;\n  }\n}\n\n@media (max-width: 430px) {\n  .promo-slider {\n    margin-bottom: 30px;\n  }\n\n  .promo-slider__slide {\n    border-radius: 14px;\n  }\n\n  .promo-slider__empty-hint {\n    padding: 12px;\n    font-size: 13px;\n  }\n\n  .promo-slider__backdrop {\n    padding: 12px;\n  }\n\n  .promo-slider__modal {\n    padding: 14px 14px;\n    border-radius: 14px;\n  }\n\n  .promo-slider__modal-title {\n    margin-bottom: 8px;\n    font-size: 18px;\n  }\n\n  .promo-slider__modal-text,\n  .promo-slider__modal-code {\n    font-size: 14px;\n    margin-bottom: 12px;\n  }\n\n  .promo-slider__modal-close {\n    width: 100%;\n    padding: 9px 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
